import * as React from "react";
const IconCall = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity={0.4}
      d="M21.9863 18.9924V17.3465C21.9863 16.5287 21.4884 15.7933 20.7291 15.4895L18.695 14.6759C17.7292 14.2896 16.6285 14.7081 16.1633 15.6384L15.9863 15.9924C15.9863 15.9924 13.4863 15.4924 11.4863 13.4924C9.48633 11.4924 8.98633 8.99243 8.98633 8.99243L9.34034 8.81542C10.2707 8.35024 10.6892 7.24957 10.3029 6.28379L9.48922 4.24965C9.18549 3.49033 8.45007 2.99243 7.63226 2.99243H5.98633C4.88176 2.99243 3.98633 3.88786 3.98633 4.99243C3.98633 13.829 11.1498 20.9924 19.9863 20.9924C21.0909 20.9924 21.9863 20.097 21.9863 18.9924Z"
      fill={props.color || "#1C1C2C"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.2363 6.99243C13.2363 6.57822 13.5721 6.24243 13.9863 6.24243C14.6101 6.24243 15.2278 6.36529 15.8041 6.604C16.3804 6.84271 16.904 7.1926 17.3451 7.63367C17.7862 8.07475 18.136 8.59839 18.3748 9.17469C18.6135 9.75098 18.7363 10.3687 18.7363 10.9924C18.7363 11.4066 18.4005 11.7424 17.9863 11.7424C17.5721 11.7424 17.2363 11.4066 17.2363 10.9924C17.2363 10.5656 17.1523 10.143 16.9889 9.74871C16.8256 9.3544 16.5862 8.99613 16.2844 8.69433C15.9826 8.39254 15.6244 8.15315 15.23 7.98982C14.8357 7.8265 14.4131 7.74243 13.9863 7.74243C13.5721 7.74243 13.2363 7.40665 13.2363 6.99243Z"
      fill={props.color || "#1C1C2C"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.2363 2.99243C13.2363 2.57822 13.5721 2.24243 13.9863 2.24243C15.1354 2.24243 16.2732 2.46876 17.3348 2.90849C18.3964 3.34821 19.361 3.99273 20.1735 4.80525C20.986 5.61776 21.6305 6.58235 22.0703 7.64395C22.51 8.70555 22.7363 9.84337 22.7363 10.9924C22.7363 11.4066 22.4005 11.7424 21.9863 11.7424C21.5721 11.7424 21.2363 11.4066 21.2363 10.9924C21.2363 10.0403 21.0488 9.09759 20.6845 8.21798C20.3201 7.33837 19.7861 6.53913 19.1129 5.86591C18.4396 5.19268 17.6404 4.65865 16.7608 4.29431C15.8812 3.92996 14.9384 3.74243 13.9863 3.74243C13.5721 3.74243 13.2363 3.40665 13.2363 2.99243Z"
      fill={props.color || "#1C1C2C"}
    />
  </svg>
);
export default IconCall;
